// import AOS - on sroll library
import AOS from 'aos';

// import swiper - slider library
import Swiper from 'swiper/swiper-bundle.js';

import ScrollButton from './backToTop.js';

const scrollButton = new ScrollButton();

// Init AOS library
AOS.init();

// shrink navbar on scroll
window.onscroll = function () {scrollFunction(); scrollButton.scrollFunction();};

function scrollFunction() {
  if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
    if (window.screen.availWidth > 767) {
      document.getElementById("mainNav").style.padding = "5px 0 25px 0";
      document.getElementsByClassName("navbar__logo")[0].style.maxHeight = "90px";
      document.querySelectorAll(".nav-link").forEach(link => {link.style.color = "white"});
      document.getElementById("mainNav").classList.add("navbar-shrink");
    }
  } else {
    if (window.screen.availWidth > 767) {
      document.getElementById("mainNav").style.padding = "1rem 1rem";
      document.getElementsByClassName("navbar__logo")[0].style.maxHeight = "120px";
      document.querySelectorAll(".nav-link").forEach(link => {link.style.color = "#ffa0b1"});
      document.getElementById("mainNav").classList.remove("navbar-shrink");
    }

  }
}


document.addEventListener("DOMContentLoaded", function(){

  el_autohide = document.querySelector('.navbar');
  
  // add padding-top to bady (if necessary)
  navbar_height = document.querySelector('.navbar').offsetHeight;
  // document.body.style.paddingTop = navbar_height + 'px';

  if(el_autohide && window.screen.availWidth < 767){
    var last_scroll_top = 0;
    window.addEventListener('scroll', function() {
          let scroll_top = window.scrollY;
         if(scroll_top < last_scroll_top) {
              el_autohide.classList.remove('scrolled-down');
              el_autohide.classList.add('scrolled-up');
          }
          else {
              el_autohide.classList.remove('scrolled-up');
              el_autohide.classList.add('scrolled-down');
          }
          last_scroll_top = scroll_top;
    }); 
    // window.addEventListener
  }
  // if

}); 
// DOMContentLoaded  end

// opinion slider settings

const swiper = new Swiper(".mySwiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // when window width is >= 320px
    768: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 20
    },
  }
});


// Media query for screen size <= 576px (mobile)
// if (window.matchMedia('(max-width: 576px)').matches) {

  // const cakeSwiperCreative = new Swiper('.cakeSwiper', {
  //   // Set options here
  //   grabCursor: true,
  //   effect: "creative",
  //   creativeEffect: {
  //     prev: {
  //       shadow: true,
  //       translate: [0, 0, -400],
  //     },
  //     next: {
  //       translate: ["100%", 0, 0],
  //     },
  //   },
  //   autoplay: true,
  // });

//   const cakeSwiperCoverflow = new Swiper('.cakeSwiper', {
//     // Set options here
//     effect: 'coverflow',
//     coverflowEffect: {
//       rotate: 0,
//       stretch: 0,
//       depth: 100,
//       modifier: 2,
//       slideShadows: true,
//     },

//     centeredSlides: true,
//     slidesPerView: "auto",
//     speed: 3500,
//     autoplay:
//     {
//       delay: 0,
//     },
//     loop: true,

//     breakpoints: {
//       1600: {
//         slidesPerView: 4,
//       },
//     }
//   });
// }

// Media query for screen size > 576px (desktop)
// if (window.matchMedia('(min-width: 577px)').matches) {
  const cakeSwiperCoverflow = new Swiper('.cakeSwiper', {
    lazy: true,
    // Set options here

    centeredSlides: true,
    slidesPerView: "auto",
    speed: 3500,
    // autoplay:
    // {
    //   disableOnInteraction: false,
    // pauseOnMouseEnter: true,
    //   delay: 0,
    // },
    loop: true,

    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1600: {
        slidesPerView: "auto",
      },
    },
  });
// }


// // Pobierz link do elementu anchor
// document.addEventListener('DOMContentLoaded', function () {
//   const galleryLink = document.querySelector('a[href="offer.html"]');

//   if (galleryLink) {
// // Przechwyć kliknięcie w link
// galleryLink.addEventListener('click', (event) => {
//   event.preventDefault(); // Zapobiegnij domyślnemu zachowaniu przekierowania
//   console.log('Kliknięto link do galerii');

//   // Zaktualizuj adres URL na /oferta bez przeładowywania strony
//   history.pushState(null, null, '/oferta');
//   console.log('Zaktualizowano adres URL na /oferta');
//   // Tutaj można dodać kod do wczytania zawartości strony offer.html i wyświetlenia jej
// });

// // Śledź zmiany adresu URL
// window.addEventListener('popstate', (event) => {
//   // Tutaj można dodać kod do wczytania i wyświetlenia zawartości strony w zależności od aktualnego adresu URL
// });
//   }
// });


// const route = (event) => {
//   event = event || window.event;
//   event.preventDefault();
//   window.history.pushState({}, "", event.target.href);
//   handleLocation();
// };

// const routes = {
//   "/oferta": "../html/offer.html",
// };

// const handleLocation = async () => {
//   const path = window.location.pathname;
//   const route = routes[path] || routes[404];
//   const html = await fetch(route).then((data) => data.text());
//   document.getElementById("main-page").innerHTML = html;
// };

// window.onpopstate = handleLocation;
// window.route = route;

// handleLocation();


// index.j

// SCROLLOWANIE DO STOPKI ////

const footer = document.getElementById("footer");

function isInViewport(element) {
  // Get the bounding client rectangle position in the viewport
  var bounding = element.getBoundingClientRect();
  
  // Checking part. Here the code checks if it's *fully* visible
  // Edit this part if you just want a partial visibility
  if (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  ) {
      // console.log('In the viewport! :)');
      // return true;
  } else {
      // console.log('Not in the viewport. :(');
      // return false;
  }
}
window.addEventListener('scroll', function (event) {
  if (isInViewport(footer)) {
    // update the element display
  }
}, false);



// initialize bootstrap tooltips
const tooltips = document.querySelectorAll('.tt');
// tooltips.forEach(tooltip => new bootstrap.Tooltip(tooltip));
tooltips.forEach(tooltip => new bootstrap.Popover(tooltip, {
  placement: 'top',
  container: 'body',
  trigger: 'hover focus',
  html: true,
}));


var popover_instance1 = bootstrap.Popover.getInstance(document.getElementsByClassName('tt')[0])
var popover_instance2 = bootstrap.Popover.getInstance(document.getElementsByClassName('tt')[1])


let content_template = `
<div class="popover" role="tooltip">
<div class="arrow"></div><div class="popover-body" onclick="copyText(event)">Jeśli podoba Ci się moja praca,</br>napisz do mnie! </br>
<a href="mailto: dopierala.tb@gmail.com" id="popover-link">dopierala.tb@gmail.com</a></div>
</div>`;
popover_instance1._config.content = content_template;//set content
popover_instance2._config.content = content_template;//set content



let lastScrollTop = 0;
const navbar = document.getElementById('mainNav');

window.addEventListener('scroll', () => {
const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

if (currentScroll > lastScrollTop) {
// Scroll w dół
navbar.classList.remove('scrolled-up');
navbar.classList.add('scrolled-down');
} else {
// Scroll w górę
navbar.classList.remove('scrolled-down');
navbar.classList.add('scrolled-up');
}

lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Zapobiegaj negatywnym wartościom scrolla
});

